import React from 'react';

export default class EmailReview extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		const previewData = {
			'recipient_name': this.props.emailData.recipient_name.value,
			'subject': this.props.emailData.ehonor_card_subject.value,
			'message': this.props.emailData.ehonor_card_message.value,
			'signature': this.props.emailData.ehonor_card_signature.value
		};

		const params = new URLSearchParams({
				product_id: this.props.selectedProduct.valueKey,
				recipient_name: previewData.recipient_name,
				ehonor_card_subject: previewData.subject,
				ehonor_card_message: previewData.message,
				ehonor_card_signature: previewData.signature,
			});
			const previewUrl = `${location.origin}/honorcard-preview?${params}`;
		
		return (
			<div className="email-review container">
				<iframe src={ previewUrl } scrolling="no"></iframe>
			</div>
		);
	}
		
}
